import { render, staticRenderFns } from "./FollowerFormTemplates.vue?vue&type=template&id=12572988&scoped=true&"
import script from "./FollowerFormTemplates.vue?vue&type=script&lang=js&"
export * from "./FollowerFormTemplates.vue?vue&type=script&lang=js&"
import style0 from "./FollowerFormTemplates.vue?vue&type=style&index=0&id=12572988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12572988",
  null
  
)

export default component.exports